import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'font-awesome/css/font-awesome.min.css';
import App from './App';
import registerServiceWorker from './utils/registerServiceWorker';
import store from './libs/store';
import DevTools from 'mobx-react-devtools';
import { config } from './config';

function devTools() {
  if (config.debug) {
    return <DevTools />;
  }
  return null;
}

ReactDOM.render(
  <Router>
    <div>
      {devTools()}
      <App store={store} />
    </div>
  </Router>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js